// SSR stub for embla-carousel — no-op carousel
export default function useEmblaCarousel() {
  return [() => {}, { scrollTo: () => {}, canScrollPrev: () => false, canScrollNext: () => false, on: () => ({}) }]
}
export function EmblaCarousel() { return null }
